import { Stack } from "@mui/material";
import React from "react";
import DrawerAppBar from "../../../components/mobile/Navbar";

import { SelectChangeEvent } from "@mui/material/Select";

import { Card } from "../Components/Card";
import ArchiveRoundedIcon from "@mui/icons-material/ArchiveRounded";
import { useNavigate } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";

export const Tasks: React.FC = () => {
  const [age, setAge] = React.useState("todo");
  const navigate = useNavigate();
  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value);
  };
  return (
    <Stack>
      <DrawerAppBar title="Minhas Tarefas" />
      {/* <Box>
        <FormControl sx={{ m: 2, minWidth: 120, float: "right" }} size="small">
          <InputLabel id="demo-select-small">Status</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={age}
            label="Age"
            onChange={handleChange}
          >
            <MenuItem value={"todo"}>A Realizar</MenuItem>
            <MenuItem value={"done"}>Realizadas</MenuItem>
          </Select>
        </FormControl>
      </Box> */}
      {/* <Stack
        direction="row"
        sx={{ display: "flex", justifyContent: "space-between", mx: "20px" }}
      >
        <Typography>Total de Tarefas</Typography>
        <Typography>13</Typography>
      </Stack> */}

      <Stack sx={{ m: "20px" }}>
        <Card
          color="#00B1C3"
          text="Guardar Mercadorias"
          icon={<ArchiveRoundedIcon fontSize="large" sx={{ color: "#FFF" }} />}
          number="1"
          onClick={() => {
            navigate("/mobile/store/", {
              replace: true,
            });
          }}
        />
        <Card
          color="#F91C63"
          text="Separar Mercadorias"
          icon={<ShoppingCartIcon fontSize="large" sx={{ color: "#FFF" }} />}
          number="1"
          onClick={() => {
            navigate("/mobile/separation", {
              replace: true,
            });
          }}
        />
        <Card
          color="#03C947"
          text="Transferir Mercadorias"
          icon={<MoveDownIcon fontSize="large" sx={{ color: "#FFF" }} />}
          number="1"
          onClick={() => {
            navigate("/mobile/transfer/position-collector", {
              replace: true,
            });
          }}
        />
        <Card
          color="#E85CF6"
          text="Conferir Mercadorias"
          icon={<RuleIcon fontSize="large" sx={{ color: "#FFF" }} />}
          number="1"
          onClick={() => {
            navigate("/mobile/check", {
              replace: true,
            });
          }}
        />
        <Card
          color="#e6e600"
          text="Auditar Posições"
          icon={<RuleIcon fontSize="large" sx={{ color: "#FFF" }} />}
          number="1"
          onClick={() => {
            navigate("/mobile/audit/position-collector", {
              replace: true,
            });
          }}
        />
        <Card
          color="#000"
          text="Inserir Estoque"
          icon={<LibraryAddIcon fontSize="large" sx={{ color: "#FFF" }} />}
          number="1"
          onClick={() => {
            navigate("/mobile/insert/position-collector", {
              replace: true,
            });
          }}
        />
      </Stack>
    </Stack>
  );
};
